import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Alerta from "../../components/alerta/Alerta";
import Loader from "../../components/loader/Loader";
import Sidebar from "../../components/sidebar/Sidebar";
import Topbar from "../../components/topbar/Topbar";
import style from "./AvaliacaoNovo.module.css";
import CriterioApi from "../../services/CriterioApi";
import { Button, Form } from "react-bootstrap";
import GraficoRadar from "../../components/graficoRadar/GraficoRadar";
import { Link } from "react-router-dom";
import { AiOutlineUp, AiOutlineDown } from "react-icons/ai";
import { MdSave } from "react-icons/md";
import AvaliacaoApi from "../../services/AvaliacaoApi";
import AlunoApi from "../../services/AlunoApi";
import { useIsMobile } from "../../components/useIsMobile/UseIsMobile";
import { Select } from "@mui/material";

function AvaliacaoNovo() {

    const location = useLocation();
    const [alunoId, setAvaliacaoId] = useState(() => {
        return location.state || localStorage.getItem("alunoId") || null;
    });
    

    const navigate = useNavigate();

    const [mostrarAlerta, setMostrarAlerta] = useState(false);
    const [mensagemAlerta, setMensagemAlerta] = useState("");
    const [tipoAlerta, setTipoAlerta] = useState("");
    const [loading, setLoading] = useState(false);
    const [criterios, setCriterios] = useState([]);
    const [valoresSelecionados, setValoresSelecionados] = useState({});
    const [visibilidadeDescricao, setVisibilidadeDescricao] = useState({});
    const [direcionadores, setDirecionadores] = useState("");
    const [pontosPositivos, setPontosPositivos] = useState("");
    const [pontosEvolucao, setPontosEvolucao] = useState("");
    const [pontosCriteriosID, setPontosCriteriosID] = useState([]);
    const [pessoa, setPessoa] = useState(null);



    const [tipoAvaliacao, setTipoAvaliacao] = useState([]);

    const [tipoAvaliacaoSelecionada, setTipoAvaliacaoSelecionada] = useState({});


    const isMobile = useIsMobile();
    const [menuHamburguerAberto, setMenuHamburguerAberto] = useState(!isMobile);

    useEffect(() => {
        setMenuHamburguerAberto(!isMobile);
    }, [isMobile]);


    const AlternarVisibilidade = (criterioId) => {
        setVisibilidadeDescricao((prevState) => ({
            ...prevState,
            [criterioId]: !prevState[criterioId],
        }));
    };

    const SelecionarNota = (criterioId, valorNota, descricao, pontoCriterioId, peso) => {
        const novosValoresSelecionados = { ...valoresSelecionados };
        let novosPontosCriteriosID = [...pontosCriteriosID];

        if (!valorNota) {
            delete novosValoresSelecionados[criterioId];

            novosPontosCriteriosID = novosPontosCriteriosID.filter(id => id !== pontoCriterioId);
        } else {
            novosValoresSelecionados[criterioId] = {
                valorNota: parseInt(valorNota),
                descricao: descricao || "",
                peso: peso || 0,
            };

            const index = criterios.findIndex(criterio => criterio.id === criterioId);
            if (index !== -1) {
                novosPontosCriteriosID[index] = pontoCriterioId;
            } else {
                novosPontosCriteriosID.push(pontoCriterioId);
            }
        }
        setValoresSelecionados(novosValoresSelecionados);
        setPontosCriteriosID(novosPontosCriteriosID);
    };

    async function ListarCriterios() {
        setLoading(true);
        try {
            const listaCriterios = await CriterioApi.ListarCriteriosAsync();
            setCriterios(listaCriterios);
        } catch (error) {
            setMensagemAlerta("Erro ao listar os critérios.");
            setTipoAlerta("erro");
            setMostrarAlerta(true);
        } finally {
            setLoading(false);
        }
    }

    async function CriarAvaliacaoAsync() {
        setLoading(true);
        try {
            let somaNotas = 0;
            let somaPesos = 0;

            criterios.forEach(criterio => {
                const nota = valoresSelecionados[criterio.id]?.valorNota || 0;
                somaNotas += nota * criterio.peso;
                somaPesos += criterio.peso;
            });

            const media = somaPesos > 0 ? (somaNotas / somaPesos).toFixed(2) : 0;

            await AvaliacaoApi.CriarAvaliacaoAsync(
                alunoId,
                media,
                pontosCriteriosID,
                pontosPositivos,
                pontosEvolucao,
                direcionadores,
                tipoAvaliacaoSelecionada.id
            );

            setMensagemAlerta("Avaliação criada com sucesso!");
            setTipoAlerta("success");
            setMostrarAlerta(true);
            navigate("/avaliacoes/aluno", { state: alunoId });
        } catch (error) {
            setMensagemAlerta("Erro ao criar avaliação.");
            setTipoAlerta("danger");
            setMostrarAlerta(true);
        }
        finally {
            setLoading(false);
        }
    }

    async function ObterPessoaPorId() {
        try {

            var dados = await AlunoApi.ObterAlunoPorPessoaId(alunoId);
            setPessoa(dados);

        } catch (error) {
            console.error("Erro ao buscar alunos!")
        }
    }

    async function ListarTipoAvaliacaoEnum() {
        try {

            var avaliacao = await AvaliacaoApi.ListarEnumTipoAvaliacao();
            setTipoAvaliacao(avaliacao)

        } catch (error) {
            console.error("Erro ao buscar alunos!")
        }
    }


    useEffect(() => {

        if (alunoId) {
            localStorage.setItem("alunoId", alunoId);
        }
        ListarTipoAvaliacaoEnum();
        ListarCriterios();
        ObterPessoaPorId();
    }, [alunoId]);

    useEffect(() => {
        return () => {
            localStorage.removeItem("alunoId");
        };
    }, []);

    return (
        <Sidebar menuHamburguerAberto={menuHamburguerAberto} setMenuHamburguerAberto={setMenuHamburguerAberto}>
            <Topbar
                menuHamburguerAberto={menuHamburguerAberto}
                setMenuHamburguerAberto={setMenuHamburguerAberto}
            >
                <Alerta
                    tipo={tipoAlerta}
                    mensagem={mensagemAlerta}
                    visivel={mostrarAlerta}
                    aoFechar={() => setMostrarAlerta(false)}
                />
                {loading && <Loader />}

                <div className={style.pagina_conteudo}>
                    <div className={style.container_cabecalho}>
                        <h4>Nova avaliação {pessoa ? `para ${pessoa.nomeCompleto}` : ''}</h4>
                    </div>

                    <Form onSubmit={(e) => { e.preventDefault(); CriarAvaliacaoAsync(); }} className={style.criterios_graficos}>
                        <div className={style.container_criterios}>
                            {criterios.map((criterio) => (
                                <div key={criterio.id} className={style.container_criterio}>
                                    <div className={style.input_select_container}>
                                        <div className={style.selectBaixo}>


                                            {valoresSelecionados[criterio.id]?.valorNota && (
                                                <Link
                                                    onClick={() => AlternarVisibilidade(criterio.id)}
                                                    id={style.botao_toggle}
                                                >
                                                    {visibilidadeDescricao[criterio.id] ? <AiOutlineUp /> : <AiOutlineDown />}
                                                </Link>
                                            )}
                                        </div>

                                        <Form.Label id={style.form_label}>{criterio.nome}</Form.Label>
                                        <Form.Group controlId={`dropdown-${criterio.id}`} className={style.selectPadrao}>
                                            <Form.Select
                                                required
                                                className={style.inputSelect}
                                                onChange={(e) => {
                                                    const selectedPonto = criterio.pontosCriterios.find(
                                                        (ponto) => ponto.valorNota.toString() === e.target.value
                                                    );
                                                    SelecionarNota(
                                                        criterio.id,
                                                        e.target.value,
                                                        selectedPonto ? selectedPonto.descricao : "",
                                                        selectedPonto ? selectedPonto.id : undefined, // Verifique se o id está sendo passado corretamente
                                                        selectedPonto ? selectedPonto.peso : 0
                                                    );
                                                }}
                                            >
                                                <option value="">Selecione uma opção</option>
                                                {criterio.pontosCriterios.map((ponto) => (
                                                    <option
                                                        key={ponto.id}
                                                        value={ponto.valorNota}
                                                        title={ponto.descricao}
                                                    >
                                                        {ponto.nota}
                                                    </option>
                                                ))}
                                            </Form.Select>
                                        </Form.Group>
                                    </div>

                                    {/* Exibição da descrição, condicional ao estado de visibilidade */}
                                    {visibilidadeDescricao[criterio.id] && valoresSelecionados[criterio.id]?.descricao && (
                                        <p className={style.descricao}>
                                            {valoresSelecionados[criterio.id].descricao}
                                        </p>
                                    )}
                                </div>
                            ))}

                            <Form.Group>
                                <Form.Label>Pontos Positivos</Form.Label>
                                <Form.Control
                                    as="textarea"
                                    placeholder="Pontos Positivos"
                                    name="pontosPositivos"
                                    onChange={(e) => setPontosPositivos(e.target.value)}
                                    required
                                />
                            </Form.Group>
                            <Form.Group>
                                <Form.Label>Pontos De Evolução</Form.Label>
                                <Form.Control
                                    as="textarea"
                                    placeholder="Pontos De Evolução"
                                    name="pontosEvolucao"
                                    onChange={(e) => setPontosEvolucao(e.target.value)}
                                    required
                                />
                            </Form.Group>
                            <Form.Group>
                                <Form.Label>Direcionadores</Form.Label>
                                <Form.Control
                                    as="textarea"
                                    placeholder="Direcionadores"
                                    name="direcionadores"
                                    onChange={(e) => setDirecionadores(e.target.value)}
                                    required
                                />
                            </Form.Group>
                            <div>

                                <Form.Group className={style.selectPadrao}>
                                    <Form.Group className={style.selectPadrao}>
                                        <Form.Select
                                            required
                                            className={style.inputSelect}
                                            value={tipoAvaliacaoSelecionada?.id || ""}
                                            onChange={(e) => {
                                                const idSelecionado = Number(e.target.value);
                                                const tipo = tipoAvaliacao.find(t => t.id === idSelecionado);
                                                if (tipo) setTipoAvaliacaoSelecionada(tipo);
                                            }}
                                        >
                                            {/* Placeholder apenas se nada estiver selecionado ainda */}
                                            {!tipoAvaliacaoSelecionada?.id && (
                                                <option value="" disabled>
                                                    Selecione o tipo de avaliação
                                                </option>
                                            )}

                                            {tipoAvaliacao.map((tipo) => (
                                                <option key={tipo.id} value={tipo.id}>
                                                    {tipo.nome}
                                                </option>
                                            ))}
                                        </Form.Select>

                                    </Form.Group>


                                </Form.Group>
                            </div>
                            <div className={style.div_botao_salvar}>

                                <Button
                                    type="button"
                                    onClick={CriarAvaliacaoAsync}
                                >
                                    <MdSave /> Salvar
                                </Button>
                            </div>
                        </div>

                        <div className={style.grafico_radar}>
                            <GraficoRadar
                                labels={criterios.map((criterio) => criterio.nome)}
                                data={criterios.map(
                                    (criterio) =>
                                        valoresSelecionados[criterio.id]?.valorNota || 0

                                )}

                            />
                        </div>
                    </Form>
                </div>
            </Topbar>
        </Sidebar>
    );
}

export default AvaliacaoNovo;
